import moment from 'moment';

import { DATE_FORMAT } from '../../constants/format';

export const is_booking_canceled = (booking = {}) =>
  booking.canceled === true || Number(booking.canceled) === 1;

export const format_booking_date = (value) => {
  if (!value) return '';

  const parsed_value = moment(value);
  if (!parsed_value.isValid()) return value;

  return parsed_value.format(DATE_FORMAT);
};
